import { render, staticRenderFns } from "./CustomerGroupCustomersDataTableRow.vue?vue&type=template&id=6487f697&"
import script from "./CustomerGroupCustomersDataTableRow.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupCustomersDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports